import { render, staticRenderFns } from "./BuyboxResetButton.vue?vue&type=template&id=5ee7f297&scoped=true"
import script from "./BuyboxResetButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyboxResetButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyboxResetButton.vue?vue&type=style&index=0&id=5ee7f297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7f297",
  null
  
)

export default component.exports